import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AgGridAngular} from 'ag-grid-angular';
import {
    GridOptions,
    GridReadyEvent,
    FilterChangedEvent,
    ColumnMovedEvent,
    RowClickedEvent,
    CellClickedEvent,
} from 'ag-grid-community';

@Component({
    selector: 'app-ag-grid-wrapper',
    templateUrl: './ag-grid-wrapper.component.html',
})
export class AgGridWrapperComponent {
    @ViewChild('agGrid') agGrid: AgGridAngular;

    // Inputs
    @Input() gridOptions: GridOptions;
    @Input() rowData?: any[];
    @Input() columnDefs?: any[];
    @Input() frameworkComponents?: any;
    @Input() domLayout?: string;
    @Input() rowSelection?: string;
    @Input() overlayNoRowsTemplate?: string;
    @Input() height?: string;
    @Input() showGrid?: boolean = true;

    // Outputs
    @Output() gridReady = new EventEmitter<GridReadyEvent>();
    @Output() filterChanged = new EventEmitter<FilterChangedEvent>();
    @Output() columnMoved = new EventEmitter<ColumnMovedEvent>();
    @Output() rowClicked = new EventEmitter<RowClickedEvent>();
    @Output() cellClicked = new EventEmitter<CellClickedEvent>();

    onGridReady(event: GridReadyEvent) {
        this.gridReady.emit(event);
    }

    onFilterChanged(event: FilterChangedEvent) {
        this.filterChanged.emit(event);
    }

    onColumnMoved(event: ColumnMovedEvent) {
        this.columnMoved.emit(event);
    }

    onRowClicked(event: RowClickedEvent) {
        this.rowClicked.emit(event);
    }

    onCellClicked(event: CellClickedEvent) {
        this.cellClicked.emit(event);
    }
}
